import reducers from './reducers';
import * as services from './services';

export { services };
export default reducers;
